<template>
  <div>
    <div class="ai">
        <div class="chat_list_history" style="position: relative;">
            <div class="brand">
                <a :href="`/${$i18n.locale=='en'?'':$i18n.locale}`" class="c-logo">
                    <img src="@/assets/LOGO.svg" alt="HOLOWITS" class="navbar-logo" style="height: 37px;">
                </a>
            </div>
            <div class="t-btn" @click="createNewChat"><i class="el-icon-chat-dot-square"></i> NEW CHAT</div>
            <div style="padding-top: 30px; height: calc(100% - 100px - 44px - 30px);">
                <div class="label">Chat List</div>
                <ul class="chat-list">
                    <li :class="{'active': chatId === data.id, 'chat-list-li': true}" v-for="data in chatList" :key="data.id" :title="data.title">
                        <div class="chat-item" @click="chooseChat(data)">
                            <p>{{ data.title }}</p>
                            <el-popover placement="right" trigger="click" @click.native="handlePopoverClick">
                                <ul>
                                    <li>
                                        <div style="
                                            padding: 10px; 
                                            border: 1px solid rgba(199, 0, 10, 0.3137254902); 
                                            border-radius: 10px; 
                                            text-align: center;
                                            cursor: pointer;"
                                            @click="deleteChat(data.id)">
                                            DELETE
                                        </div>
                                    </li>
                                </ul>
                                <div class="opration-btn" slot="reference">···</div>
                            </el-popover>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div :class="['chat', chatId ? 'defualt_layout' : 'init_layout']">
            <div class="title"><p>{{ chatTitle }}</p></div>
            <div class="contents" ref="contents">
                <div class="messages" ref="messages">
                    <div v-for="item in messageList" :key="item.Id">
                        <div :class="{'question': item.role === 'user', 'answer': item.role === 'assistant'}" class="history-messages">
                            <div v-if="item.role === 'assistant'" class="avatar"><img src="@/assets/image/ai/wiki.png" alt=""></div>
                            <div class="history-messages-item" v-html="item.content"></div>
                        </div>
                    </div>
                </div>
                <div class="input_box">
                    <div class="big-title">
                        <img src="@/assets/image/ai/wiki2.png" alt="">
                        <!-- <h1>Hi, I'm <strong>HOLOWiki</strong></h1> -->
                        <p>HOLO Wiki—HOLOWITS' free online encyclopedia!</p>
                    </div>
                    <div class="input_box-container">
                        <textarea class="input" v-model="question" placeholder="Send Message" style="color: #000; font-size: 16px;"></textarea>
                        <div class="bar">
                            <div class="t-label">Powered By DeepSeek-R1</div>
                            <el-button class="t-btn" type="primary" size="mini" circle :disabled="loading" :loading="loading" icon="el-icon-top" @click="requestAi()"></el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { putQuestion, createChatId, getChatListById, getMessageListByChatId, deleteChat } from '@/api/aiChatApi'
import MarkdownIt  from 'markdown-it'
import DOMPurify from 'dompurify';
import MarkdownItHighlightjs from "markdown-it-highlightjs";
import "highlight.js/styles/a11y-dark.css";
import mk from 'markdown-it-katex-gpt';
// import markdownItTexmath from 'markdown-it-texmath'
// import markdownItMathJax from 'markdown-it-mathjax'
import "katex/dist/katex.min.css";
import SmartScroll from '@/utils/SmartScroll';

export default {
name: 'AIChatIndex',
data() {
    return {
        md: new MarkdownIt({
            html:           true,
            linkify:        true,
            // typographer:    true,
            breaks:         true,
            langPrefix:   'language-',
        }).use(MarkdownItHighlightjs).use(mk),
        chatId: null,
        chatTitle: '',
        chatList: [],
        messageList: [],
        divId: null, // 当发送提问后，则创建一个divId
        question: '',
        loading: false,
        isNew: false,
        scrollBlock: false
        // results: []
    }
},
async mounted() {
    if (!this.$store.state.client.user.id) {
        this.$router.push({path: '/login'})
        return false;
    }
    // await this.requestAi()
    await this.getChatListById()
},
methods: {
    handlePopoverClick(e) {
        e.stopPropagation()
    },
    async deleteChat(id) {
        if (!id) return;
        const {data: {data, isSuccess}} = await deleteChat({
            id
        })
        if (isSuccess) {
            let chats = this.chatList.filter(item => item.id !== id)
            this.chatList = chats
            this.removeElement(id)
            if (id === this.chatId) {
                this.chatId = null
                this.messageList = []
                this.chatTitle = ''
            }
            // await this.getChatListById()
        }
    },

    chooseChat({id, title}) {
        this.removeElement(this.chatId)
        this.chatId = id
        this.chatTitle = title
        this.messageList = []
        this.getMessageListByChatId()
    },
    removeElement(value) {
        // console.log(value)
        let elements =  document.querySelectorAll(`[data-chat-id="${value}"]`)
        // console.log(elements)
        for (let i = 0; i < elements.length; i++) {
            elements[i].remove()
        }
    },
    async getChatListById() {
        const {data: {isSuccess, data}} = await getChatListById()
        if (isSuccess) {
            // console.log(data)
            this.chatList = data
        }
    },
    async getMessageListByChatId() {
        const {data: {isSuccess, data}} = await getMessageListByChatId(this.chatId)
        if (isSuccess) {
            // console.log(data)
            for (let item of data) {
                item.content = this.renderMarkdown(item.content)
            }
            this.messageList = data
        }
    },
    async createChatId() {
        if (!this.question) {
            this.$message.warning("question can't be blank.")
            return false;
        }
        if (this.question.trim().length === 0) {
            this.$message.warning("question can't be blank.")
            return false;
        }
        const {data: {isSuccess, data}} = await createChatId()
        if (isSuccess) {
            this.chatId = data.id
            this.chatList.push({
                id: data.id,
                userId: this.$store.state.client.user.id,
                title: this.question
            })
        }
    },
    async putQuestion() {
        if (!this.chatId) return;
        if (!this.question) {
            this.$message.warning("question can't be blank.")
            return false;
        }
        if (this.question.trim().length === 0) {
            this.$message.warning("question can't be blank.")
            return false;
        }

        let messagesDiv = this.$refs['messages']
        let div = document.createElement("div")
        div.setAttribute('data-chat-id', this.chatId)
        messagesDiv.appendChild(div)

        div.innerHTML = 
        `
            <div class="history-messages question">
                <div class="history-messages-item">
                    <p>${this.question}</p>
                </div>
            </div>
        `

        let div2 = document.createElement("div")
        div2.setAttribute('data-chat-id', this.chatId)
        messagesDiv.appendChild(div2)

        let answer = document.createElement("div")
        answer.setAttribute("class", "history-messages answer")
        
        // 头像
        let avatar = document.createElement("div")
        avatar.setAttribute("class", "avatar")
        let img = document.createElement("img")
        img.setAttribute("src", require("@/assets/image/ai/wiki.png"))
        avatar.appendChild(img)
        answer.appendChild(avatar)

        // 思考过程 div
        let reasoningDiv = document.createElement("div")
        reasoningDiv.setAttribute("class", "history-messages-item reasoning")
        answer.appendChild(reasoningDiv)
        // 结论 div
        let contentDiv = document.createElement("div")
        contentDiv.setAttribute("class", "history-messages-item contents")
        answer.appendChild(contentDiv)
        div2.appendChild(answer)

        const smartScroll = new SmartScroll(this.$refs['contents'])

        // 这里要带上chatId和问题传给后端，后端根据chatId把问题存入数据库
        let response = null;
        try {
            response = await putQuestion({
                chatId: this.chatId,
                content: this.question,
                role: 'user'
            })
        } catch (e) {
            contentDiv.innerHTML = 'System Error...'
            this.loading = false
        }
        
        this.question = ''

        const reader = response.body.getReader()
        const decoder = new TextDecoder('utf-8') // , {stream: true}

        let reasoning = '';
        let contentText = '';

        let buffer = ""
        let countChunk = 0
        let index = 0
        while (true) {
            const {done, value} = await reader.read()
            if (done) break;
            console.log(value)
            const chunk = decoder.decode(value)
            // let lines = chunk.split('\n\n')
            
            buffer += chunk

            let lines = buffer.split('data:').filter(line => line.trim() !== '')

            if (lines.length >= countChunk) {
                countChunk = lines.length

                for (let i = index; i < lines.length; i++) {
                    let str = ''
                    try {
                        if (lines[i]) { // 判断不是空字符串
                            str = lines[i]
                            
                            let paragraph1 =  `{"reasoningContent": "`
                            let paragraph2 =  `", "content": "`
                            let paragraph3 =  `" }\n\n`

                            if ((str.indexOf(paragraph1) == -1) || (str.lastIndexOf(paragraph3) == -1)) {
                                index = i
                                break;
                            }

                            let offset1 = str.indexOf(paragraph1) + paragraph1.length - 1
                            let offset2 = str.indexOf(paragraph2) + paragraph2.length - 1
                            // let offset3 = str.lastIndexOf(paragraph3) + paragraph3.length - 1

                            let item = {
                                reasoningContent: str.substring(offset1 + 1, str.indexOf(paragraph2)), 
                                content: str.substring(offset2 + 1, str.lastIndexOf(paragraph3))
                            }

                            if (item.reasoningContent && item.reasoningContent !== 'null') {
                                reasoning += item.reasoningContent
                                let divTemp = document.createElement("div")
                                divTemp.innerHTML = this.renderMarkdown(reasoning);
                                this.diffDOM(reasoningDiv, divTemp)
                            }
                            if (item.content && item.content !== 'null') {
                                contentText += item.content
                                let divTemp = document.createElement("div")
                                divTemp.innerHTML = this.renderMarkdown(contentText);
                                this.diffDOM(contentDiv, divTemp)
                            }

                            smartScroll.scrollToBottom()
                        }
                        if (i == lines.length - 1) {
                            index = lines.length
                        }
                    } catch (e) {
                        console.error(e)
                        console.error(str)
                        index = i
                        break;
                    }
                }
            }
        }
        smartScroll.stop()
    },
    renderMarkdown(markdownText) {
        // 将 Markdown 转换为 HTML
        const htmlContent = this.md.render(markdownText);
        const sanitizedHTML = DOMPurify.sanitize(htmlContent);
        return sanitizedHTML
    },
    diffDOM(oldNode, newNode) {
        const oldChildren = oldNode.childNodes;
        const newChildren = newNode.childNodes;

        // 遍历子节点
        for (let i = 0; i < newChildren.length; i++) {
            const newChild = newChildren[i];
            const oldChild = oldChildren[i];

            if (!oldChild) {
                // 如果旧节点不存在，直接添加新节点
                oldNode.appendChild(newChild.cloneNode(true));
            } else if (newChild.nodeType === Node.TEXT_NODE && oldChild.nodeType === Node.TEXT_NODE) {
                // 如果是文本节点，更新文本内容
                if (newChild.textContent !== oldChild.textContent) {
                    oldChild.textContent = newChild.textContent;
                }
            } else if (newChild.nodeName === oldChild.nodeName) {
                // 如果是相同类型的元素节点，递归对比子节点
                this.diffDOM(oldChild, newChild);
            } else {
                // 如果节点类型不同，替换旧节点
                oldNode.replaceChild(newChild.cloneNode(true), oldChild);
            }
            // 高亮代码块
            // Prism.highlightAllUnder(oldNode);
        }

        // 删除多余的旧节点
        while (oldChildren.length > newChildren.length) {
            oldNode.removeChild(oldNode.lastChild);
        }
    },
    async requestAi() {
        // 判断是否有chatId，有则不用创建，说明不是新开一个对话
        try {
            this.loading = true
            if (!this.chatId) {
                await this.createChatId()
                this.chatTitle = this.question
            }
            await this.putQuestion()
            this.loading = false
        } catch (e) {
            this.loading = false
        }
    },
    createNewChat() {
        if (this.chatId) {
            this.chatTitle = ''
            this.removeElement(this.chatId)
        }
        this.chatId = null
        this.messageList = []
    }
}
}
</script>

<style>
    .el-popover {
        min-width: 100px;
    }
</style>

<style lang="scss" scoped>
.ai {
    height: 100vh;
    display: flex;
    .chat_list_history {
        width: 300px;
        background-color: #f7f7f7;
        padding: 0 20px;

        .brand {
            height: 100px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
        }

        .t-btn {
            padding: 10px 20px;
            font-weight: 600;
            border: 2px solid  var(--themeColor);
            border-radius: 15px;
            transition: all 0.4s;
            display: flex;

            &:hover {
                background-color: var(--themeColor);
                color: white;
            }

            i {
                font-size: 20px; 
                font-weight: 600;
                margin-right: 10px;
            }
        }

        .label {
            margin-top: 10px;
            color: gray;
            font-weight: 500;
        }

        .chat-list {
            // max-height: 700px;
            height: calc(100% - 20px);
            overflow: auto;

            .chat-list-li {
                // height: 50px;
                line-height: 40px;
                padding: 0 10px;
                margin-top: 10px;
                transition: all 0.35s;
                font-weight: 600;
                border-radius: 10px;
                cursor: pointer;

                .chat-item {
                    display: flex;
                    justify-content: space-between;
                    position: relative;

                    .opration-btn {
                        display: none;
                    }
                }

                p {
                    white-space: nowrap; /* 防止文本换行 */
                    overflow: hidden; /* 隐藏溢出的内容 */
                    text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本 */
                }

                &:hover {
                    background-color: var(--themeColor);
                    color: white;

                    .opration-btn {
                        display: block;
                    }
                }
            }
        }

        

        .active {
            background-color: var(--themeColor);
            color: white;
        }
    }
    .defualt_layout {
        .big-title {
            display: none;
        }
    }
    .init_layout {
        
       .title {
            display: none;
       }
       .messages {
            display: none;
       }
       .big-title {
            display: block;
       }
       .contents {
            justify-content: center; /* 垂直居中 */
            align-items: center; /* 水平居中 */
            padding-top: 0px;

            .input_box {
                margin: 0 !important;
                position: static !important;
            }
       }
       
    }
    .chat {
        width: calc(100% - 300px);
        height: 100%;
        display: flex;
        flex-direction: column;

        .title {
            height: 60px;
            text-align: center;
            line-height: 60px;
            font-size: 18px;
            border-bottom: 1px solid #e7e7e7;
        }

        .contents {
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow: auto;
            padding-top: 30px;

            .big-title {
                // display: block;
                // display: flex;
                // flex-direction: column;
                // align-items: center;
                margin-bottom: 30px;

                img {
                    display: block;
                    width: 300px;
                    margin: 0 auto;
                    // margin-right: 20px;
                }
                h1 {
                    text-align: center;
                }
                p {
                    font-size: 20px;
                    width: 600;
                    text-align: center;
                }
            }

            ::v-deep.messages {
                flex-grow: 1;
                width: 800px;
                // width: 730px;
                margin: 0 auto 30px;
                padding-left: 55px;

                .question {
                    // text-align: right;
                    display: flex;
                    justify-content: flex-end;
                    .history-messages-item {
                        max-width: 450px;
                        padding: 10px 20px 0px;
                        background-color: var(--themeColor);
                        color: white;
                        border-radius: 7px;
                        position: relative;

                        &::after {
                            content: '';
                            width: 10px;
                            height: 10px;
                            position: absolute;
                            right: -10px;
                            top: 10px;
                            border-top: 5px solid transparent;
                            border-right: 5px solid transparent;
                            border-bottom: 5px solid transparent;
                            border-left: 5px solid var(--themeColor);
                        }
                    }
                }

                .answer {
                    padding-top: 20px;
                    padding-bottom: 30px;

                    position: relative;

                    .avatar {
                        position: absolute;
                        width: 50px;
                        height: 50px;
                        top: 20px;
                        left: -70px;
                        // background-color: #eb111c10;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 80%;
                            height: 80%;
                        }
                    }
                }

                .history-messages {
                    .reasoning {
                        color: #9e9e9e;
                        
                        p {
                            font-size: 14px !important;
                        }
                    }
                    .history-messages-item {
                        & > * {
                            margin-bottom: 10px;
                        }

                        p {
                            font-size: 16px;
                        }

                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
                        
                        th, td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        
                        th {
                            background-color: #f2f2f2;
                        }

                        ol,ul {
                            padding-left: 24px;
                            li+li {
                                margin-top: 5px;
                            }
                        }
                    }
                }

            }

            .input_box {
                position: sticky;
                bottom: 0;
                margin-bottom: 20px;
            }

            .input_box-container {
                margin: auto;
                width: 820px;
                // height: 150px;
                border-radius: 18px;
                // background-color: #8080801f;
                background-color: #f7f7f7;
                // border: 1px solid #0000001a;
                border: 1px solid #c7000b1f;

                .input {
                    width: 100%;
                    height: 100px;
                    padding: 20px;
                    outline: none;
                    border: 0;
                    resize: none;
                    background: none;
                }

                .bar {
                    height: 49px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    padding: 10px;

                    ::v-deep.t-btn {
                        font-size: 15px; 
                        font-weight: 600;
                    }

                    .t-label {
                        padding: 4px 10px;
                        background-color: #c7000a10;
                        border: 1px solid #c7000a50;
                        border-radius: 10px;
                        color: #c7000aab;
                    }
                }
                .bar > * {
                    margin-left: 20px;
                }
            }
        }
    }
}
</style>